import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {permalinkDetails_template} from "../components/templates/permalinkDetails_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class permalinkDetails extends vnModule_knockoutJS{

    protected permalinkDetails_template: permalinkDetails_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'permalinkDetails';
    }


    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Page Path Details');

        this.permalinkDetails_template = new permalinkDetails_template('permalinkDetails', this.viewModel, this)
        this.template = this.permalinkDetails_template;

        return [this.permalinkDetails_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        // scroll to top
        window.scrollTo(0, 0);

        this.permalinkDetails_template.buildDatePickerCalendar();
        this.permalinkDetails_template.setMetricFilterItems();
        this.permalinkDetails_template.setRangeFilterItems();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void{

        this.loadingIn(this.permalinkDetails_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.permalinkDetails_template.getViewModelForRequest();

        let usrReq_url: string = '/api/permalink_details/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    //Last page from History
                    let lastPage = "";
                    for (var i = obj.vnAppZone.app.routeHistory.length - 1; i >= 0; i--) {

                        if (!obj.vnAppZone.app.routeHistory[i].includes('/permalink_details')) {

                            lastPage = obj.vnAppZone.app.routeHistory[i];
                            break;
                        }
                    }

                    // fallback to referrer
                    if (lastPage == "") {

                        lastPage = document.referrer;
                    }

                    if (obj.permalinkDetails_template.getTemplateViewModel().referrer() == "") {

                        obj.permalinkDetails_template.setReferrer(lastPage);
                    }
                    
                    let responseParsed = JSON.parse(req.request.response);

                    // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                    obj.zoneHeader?.loadedModule.showPlanPromo();

                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getSampledDates();
                    obj.getIndicatorsDataByDateRange();
                    obj.getIndicatorsTotalsDataByDateRange();
                    obj.permalinkDetails_template.setDatesSelected();
                }
            }

            obj.loadingOut(obj.permalinkDetails_template.builtTemplate.querySelector("#report-results"));
        }
    }

    protected updateFilters(responseParsed: any): void{

        this.permalinkDetails_template.setDynamicFilters(responseParsed.dynamicFiltersData);
        this.permalinkDetails_template.setDefaultDevices();
    }

    public getSampledDates(): void{

        let subViewModel = this.permalinkDetails_template.getViewModelForRequest();
        let baseApiUrl = '/api/permalink_details/sampledDates/get/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onSampledDatesRequestReturn;
        this.XHRHdl.execute();
    }

    public getIndicatorsDataByDateRange(): void{

        this.loadingIn(this.permalinkDetails_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);

        this.permalinkDetails_template.clearTimelineAnnotatonData();

        let subViewModel = this.permalinkDetails_template.getViewModelForRequest();

        let baseApiUrl = '/api/permalink_details/indicatorsByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIndicatorsByDateDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getIndicatorsDataByDateRange');
            
    }

    public getIndicatorsTotalsDataByDateRange(): void{

        this.loadingIn(this.permalinkDetails_template.builtTemplate.querySelector("#indicatorsTotals-results"), true);

        let subViewModel = this.permalinkDetails_template.getViewModelForRequest();

        let baseApiUrl = '/api/permalink_details/indicatorsTotalsByDate/get/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onIndicatorsTotalsByDateDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onSampledDatesRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateSampledDatesData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onIndicatorsByDateDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                        
                obj.updateIndicatorsData(responseParsed);
                obj.permalinkDetails_template.updateIndicatorsGraphData();
            })

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.permalinkDetails_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
                }
            }
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onIndicatorsTotalsByDateDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.updateIndicatorsTotalsData(responseParsed);
            })

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    // LOADING : ends
                    obj.loadingOut(obj.permalinkDetails_template.builtTemplate.querySelector("#indicatorsTotals-results"), true);
                }
            }
        }
    }

    protected updateSampledDatesData(responseParsed: any): void{

        this.permalinkDetails_template.setSampledDatesData(responseParsed.sampledDatesData);
    }

    protected updateIndicatorsData(responseParsed: any): void{

        this.permalinkDetails_template.setDeviceView(this.getVnAppZone().getCookie('deviceView'));
        this.permalinkDetails_template.setBrandShortName(responseParsed.brandShortName);
        this.permalinkDetails_template.setIndicatorsData(responseParsed.indicatorsData);
        this.permalinkDetails_template.setGraphLinesInfo(responseParsed.graphLinesInfo);
        this.permalinkDetails_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData);

    }

    protected updateIndicatorsTotalsData(responseParsed: any): void{

        this.permalinkDetails_template.setBrandShortName(responseParsed.brandShortName);
        this.permalinkDetails_template.setIndicatorsTotalsData(responseParsed.indicatorsData);
    }

     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

        if(element=='segmentsFilter'){

            this.getIndicatorsDataByDateRange();
            this.getIndicatorsTotalsDataByDateRange();
        }

        if(element=='viewModeFilter'){

            this.getIndicatorsDataByDateRange();
            this.getIndicatorsTotalsDataByDateRange();
        }
    }

    protected filterDateOnChange(element) {

        this.getSampledDates();
        this.getIndicatorsDataByDateRange();
        this.getIndicatorsTotalsDataByDateRange();
        this.permalinkDetails_template.setDatesSelected();
    }

    protected filterSimpleOnChange(){

        this.getIndicatorsDataByDateRange();
        this.getIndicatorsTotalsDataByDateRange();
    }

    protected filterMultipleSelectorOnChange(){

        this.getIndicatorsDataByDateRange();
        this.getIndicatorsTotalsDataByDateRange();
    }

    protected filterSingleGroupSelectorOnChange(id){
        
        if(id == 'metricFilter'){

            this.permalinkDetails_template.onIndicatorGroupSwitch();

            let viewModelParams = this.permalinkDetails_template.getViewModelForRequest();

            let filterParams = viewModelParams;
            if(viewModelParams['filters']){
                filterParams = viewModelParams['filters'];
            }
            this.updateFilterUrl('/', filterParams);

            this.permalinkDetails_template.updateIndicatorsGraphData()

        } else {
            this.getIndicatorsDataByDateRange();
            this.getIndicatorsTotalsDataByDateRange();
        }

    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public getReportData(): void{

        this.getIndicatorsDataByDateRange();
        this.getIndicatorsTotalsDataByDateRange();

    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);

        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.permalinkDetails_template.setResultPage(totalCount, totalPage, execTime);
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {
    
        let subViewModel = this.permalinkDetails_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/permalink_details/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.permalinkDetails_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }

}


// WEBPACK FOOTER //
// ./js/modules/permalinkDetails.ts